import { FC, useEffect } from "react";
import { PaymentGroupsButton, SelectPaymentGroupContainer } from "./selectPaymentGroup.styles";
import PaymentInfo from "../../constants/paymentInfo";
import degreeType from "../../../../../../../../core/types/degreeType";
import paymentType from "../../types/paymentType";

const SelectPaymentGroup: FC<{
  degree: degreeType;
  paymentGroups: Record<paymentType, PaymentInfo> | null;
  selectedPaymentType: paymentType | null;
  setSelectedPaymentType: (paymentType: paymentType) => void;
}> = ({ degree, paymentGroups, selectedPaymentType, setSelectedPaymentType }) => {
  useEffect(() => {
    if (paymentGroups) {
      const lastViewedGroupName = localStorage.getItem(`${degree}EducationListPaymentGroup`);
      const notEmptyPaymentGroup = Object.values(paymentGroups).find(
        (group) => group.applications.length
      );

      if (!lastViewedGroupName) {
        localStorage.setItem(`${degree}EducationListPaymentGroup`, notEmptyPaymentGroup.name);
        setSelectedPaymentType(notEmptyPaymentGroup.name);
        return;
      }

      if (lastViewedGroupName in paymentGroups) {
        setSelectedPaymentType(lastViewedGroupName as paymentType);
      } else {
        setSelectedPaymentType(notEmptyPaymentGroup.name);
      }
    }
  }, [paymentGroups]);

  if (!paymentGroups) return null;

  const onSelectedPaymentType = (group: PaymentInfo): void => {
    localStorage.setItem(`${degree}EducationListPaymentGroup`, group.name);
    setSelectedPaymentType(group.name);
  };

  return (
    <SelectPaymentGroupContainer>
      {Object.values(paymentGroups).map((group) => (
        <PaymentGroupsButton
          type="button"
          key={group.name}
          $active={group.name === selectedPaymentType}
          onClick={(): void => onSelectedPaymentType(group)}
          disabled={group.disabled}
        >
          {group.viewedName}
        </PaymentGroupsButton>
      ))}
    </SelectPaymentGroupContainer>
  );
};

export default SelectPaymentGroup;
